import utility from './utility'
import option from './option'
import account from './api/account'
import brain from './api/brain'
import common from './api/common'
import docs from './api/docs'
import studio from './api/studio'
import subscription from './api/subscription'
import notebook from './api/notebook'

export default {
  mixins: [
    utility,
    option,
    account,
    brain,
    common,
    docs,
    studio,
    subscription,
    notebook,
  ],
}
